<template>
  <div class="tw-p-5 tw-flex tw-flex-col tw-gap-5">
    <div>Chosen subscription</div>

    <div>
      <div v-if="changeMode">
        <onboarding-price-select-dropdown :prices="prices"
                                          :title="selectedSubscription.title"
                                          :selected="false"
                                          v-model="selectedPriceId"/>
      </div>
      <div v-else>
        <div class="tw-flex tw-justify-between">
          <div class="tw-font-medium">{{ selectedSubscription.title }}</div>
          <button class="btn btn-link p-0" @click="changeMode = true">Change</button>
        </div>
      </div>
    </div>

    <radio-button title="Pay via credit card"
                  :selected="paymentMethod === 'card'"
                  @click="paymentMethod = 'card'"/>

    <onboarding-stripe-subscription v-show="paymentMethod === 'card'"
                                    @success="handleSubscriptionSuccess"
                                    :selected-price-id="selectedPriceId"
                                    :agreement="agreement"/>


    <radio-button title="Pay via purchase order"
                  v-if="hasPurchaseOrder"
                  :selected="paymentMethod === 'purchase_order'"
                  @click="paymentMethod = 'purchase_order'"/>


    <onboarding-purchase-order-subscription v-show="paymentMethod === 'purchase_order'"
                                            v-if="hasPurchaseOrder"
                                            @success="handleSubscriptionSuccess"
                                            :selected-price-id="selectedPriceId"
                                            :agreement="agreement"/>

  </div>
</template>

<script>

import PublicPurchaseForm from "../Assets/PublicPurchaseForm.vue";
import GeneralMixins from "../../../mixins/GeneralMixins.js";
import OnboardingPriceSelectDropdown from "./OnboardingPriceSelectDropdown.vue";
import RadioButton from "./RadioButton.vue";
import PaymentCardForm from "../Payments/PaymentCardForm.vue";
import OrganizationBillingFormInputsSlim from "../Assets/OrganizationBillingFormInputsSlim.vue";
import OnboardingStripeSubscription from "./OnboardingStripeSubscription.vue";
import OnboardingPurchaseOrderSubscription from "./OnboardingPurchaseOrderSubscription.vue";
import {OrganizationsApi} from "../../Api/OrganizationsApi.js";
import AgreeSubscription from "./AgreeSubscription.vue";

export default {
  components: {
    AgreeSubscription,
    OnboardingPurchaseOrderSubscription,
    OnboardingStripeSubscription,
    OrganizationBillingFormInputsSlim,
    PaymentCardForm, RadioButton, OnboardingPriceSelectDropdown, PublicPurchaseForm
  },
  mixins: [GeneralMixins],

  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    selectedSubscription: {
      type: Object,
      required: true
    },
    prices: {
      type: Array,
      required: true
    },
    selectTitle: {
      type: String,
      required: true
    },
    agreement: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      organization: null,
      changeMode: false,
      paymentMethod: 'card',
      code: null,
      publicPaymentCompleted: false,
      email: null,
      stripeDiscount: null,
      // organizationAddress: null,
      // stripeAddress: null,
      // firstName: null,
      // lastName: null,
      // saving: false,
      // error: null,
      // acceptedTerms: false
    };
  },

  methods: {
    handleSubscriptionSuccess() {
      this.$emit('success')
    }
  },

  async mounted() {
    this.organization = await OrganizationsApi.getOrganization()
  },

  computed: {
    hasPurchaseOrder() {
      if (!this.organization) { return false }
      return ['agency', 'enterprise'].includes(this.organization.organization_type)
    },

    selectedPriceId: {
      get() {
        return this.value
      },
      set(selectedPriceId) {
        this.$emit('input', selectedPriceId)
      }
    },

    selectedSubscriptionIntervalLabel() {
      if (this.selectedSubscription.plan.identifier === "month") {
        return "Monthly"
      }
      return "Yearly"
    },

    buttonTitle() {
      if (!this.selectedSubscription.plan) {
        return "Select a Plan"
      }

      return `Start a ${this.selectedSubscription.plan.interval === 'month' ? 'Monthly' : 'Yearly'} Subscription`
    },
  },
}
</script>
